import gql from 'graphql-tag';
import { subUnitFragments } from './SubUnit';
import { occupationFragments } from './Occupation';


export const workRelationFragments = gql`
  fragment workRelationFragments on WorkRelation {
    id
    subUnit {
      ...subUnitFragments
    }
    occupation {
      ...occupationFragments
    }
    leaveAndLayoffs {
      id
      description
      endDate
      leaveId
      percentageLeave
      startDate
      isSentToAltinn
      isEndDateSentToAltinn
    }
    startDate
    endDate
    pensionEndDate
    endReason
    durationType
    samePositionSince
    shiftType
    employmentType
    employmentPercentage
    employmentPercentageUpdated
    hoursEveryWeekWithFullEmployment
    lastSalaryChange
    sentToAltinn
    endDateSentToAltinn
  }
  ${subUnitFragments}
  ${occupationFragments}
`;

export const workRelationDisplayFragments = gql`
  fragment workRelationDisplayFragments on WorkRelation {
    id
    employmentPercentage
    employmentType
    occupation {
      id
      name
    }
    employee {
      id
      firstName
      lastName
    }
  }
`;
